import React from "react";
import { Image } from "react-bootstrap";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import moment from "moment";
import ViewTransactionModal from "../../superAdminComponents/superAdminAllComponent/superAdminUserWallatTransactions/ViewTransactionModal";
import NoContent from "../../reusableComponents/NoContentComponent";

function TableHeadScan(props) {
  return (
    <tr>
      <th style={{ width: "25%" }}>Transaction ID</th>
      <th style={{ width: "20%" }}>User Name</th>
      <th style={{ width: "15%" }}>Payment Status</th>
      <th style={{ width: "15%" }}>Date & Time</th>
      <th style={{ width: "10%" }}>Amount</th>
    </tr>
  );
}

export default TableHeadScan;

export const TableBodyScan = (props) => {
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              {props.auth.secondary_loader ? (
                <SmallLoader />
              ) : (
                !isEmpty(props.paymentOrder) ?
                props?.paymentOrder
                  .slice(props?.start, props?.end)
                  .map((item, index) => {
                    return (
                      <tr
                        className="sd_body_table-row"
                        // style={{ textAlign: "center" }}
                      >
                        <td
                          style={{
                            width: "25%",
                            paddingLeft: "1.75rem",
                          }}
                        >
                          <div className="f12-500">
                            {item?.transactionNumber || item?._id}
                          </div>
                        </td>
                        <td style={{ width: "20%" }} className="text-center">
                          <div className="d-flex align-items-center">
                            <div className="super-admin-suggestion-table-body-boxone">
                              {item?.restaurant_id?.point_of_contact[0]
                                ?.profile_Photo ? (
                                <div className="super-admin-suggestion-imageBoxOne enIMG33">
                                  <Image
                                    fluid
                                    src={
                                      item?.restaurant_id?.point_of_contact[0]
                                        ?.profile_Photo
                                    }
                                    alt="Icon"
                                    className="rounded-circle"
                                  />
                                </div>
                              ) : (
                                <div className="super-admin-suggestion-imageBoxOne enIMG33">
                                  <Image
                                    fluid
                                    src={require("../../../assets/images/ActionImages/demoprofile.jpg")}
                                    alt="Icon"
                                    className="rounded-circle"
                                  />
                                </div>
                              )}
                            </div>
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-500">
                                {item?.user_id?.first_name}&nbsp;
                                {item?.user_id?.last_name}
                              </div>
                            </div>
                          </div>
                        </td>
                        {/* <td style={{ width: "20%" }}>
                  <div className="f12-500">Walk in</div>
                </td> */}
                        <td style={{ width: "15%" }}>
                          <div className="f12-500">
                            {/* enSuccessLBL */}
                            {item?.payment_captured ? (
                              <div
                                className="badge badge-success p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                Success
                              </div>
                            ) : (
                              <div
                                className="badge badge-warning p-2"
                                style={{ borderRadius: "1rem", color: "white" }}
                              >
                                Pending
                              </div>
                            )}
                          </div>
                        </td>

                        <td style={{ width: "15%" }}>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("Do MMM YYYY")}
                          </div>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("hh:mm A")}
                          </div>
                        </td>
                        <td style={{ width: "5%" }}>
                          <div className="f12-500">₹ {item?.amount}</div>
                        </td>
                        <td style={{ width: "5%" }}>
                          <ViewTransactionModal
                            data={item}
                            scan_and_pay={{
                              type: "Scan & Pay",
                              _id: item?.razorpay_order_details?.receipt,
                            }}
                          />
                        </td>
                      </tr>
                    );
                  }):<NoContent/>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
